<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar
      @goOnePage="butsIndex = 0"
      :goodsNumber="goodsNumber"
      :tabbarIndex="3"
      :tabbarInfoShow="false"
    ></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
	<div class="df-maina-ddtit"><span>{{btns[butsIndex].name}}</span></div>
	<div class="df-maina">
	<div class="df-spzx-da">
		<div
			:ref="'btn' + index"
			:class="index == butsIndex ? 'df-spzx-dabox on' : 'df-spzx-dabox'"
			@click="clickedBtns(index)"
			v-for="(item, index) of btns"
			:key="index"
		>
			<div class="df-spzx-dam">{{ item.name }}</div>
			<div class="df-spzx-daico"></div>
		</div>
	</div>
	
	<div class="df-mainar">
    <div class="main1-container">
      <div class="main flexStyle3">
        <!--<div class="left">
          <user-info></user-info>
          <div class="bottom">
            <div
              :class="index == butsIndex ? 'hands item item-on' : 'hands item'"
              @click="clickedBtns(index)"
              v-for="(item, index) of btns"
              :key="index"
            >
              <div class="left oneLine">{{ item.name }}</div>
              <div v-if="index == butsIndex" class="right rightright"></div>
            </div>
          </div>
        </div>-->

        <!-- 会员信息->会员信息 -->
        <user-info-detail
          v-if="btns[butsIndex].name == '会员信息'"
        ></user-info-detail>
        <!-- 会员信息->会员信息 -->

        <!-- 个人信息->修改密码 -->
        <change-password
          v-if="btns[butsIndex].name == '修改密码'"
        ></change-password>
        <!-- 个人信息->修改密码 -->

        <!-- 个人信息->收货地址 -->
        <address-list
          :obj="obj"
          v-if="btns[butsIndex].name == '收货地址'"
        ></address-list>
        <!-- 个人信息->收货地址 -->
      </div>
    </div>
    </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import userInfo from "../../components/userInfo/userInfo";
import userInfoDetail from "./components/userInfoDetail";
import changePassword from "./components/changePassword";
import addressList from "./components/addressList";
import { shoppingCarNumber } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      btns: [
        // 1.1.buttons
        { name: "会员信息", id: 1 },
        { name: "修改密码", id: 2 },
        { name: "收货地址", id: 3 },
      ],
      butsIndex: 0, // 1.2.当前激活按钮
      token: "", // 1.3.token
      goodsNumber: 0, // 1.4.购物车商品数量
      obj: null,
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.页面顶部部分
    cFooter: footer, // 2.2.页面底部
    userInfo, // 2.3.左侧右上角客户信息
    userInfoDetail, // 2.4.右侧下部分个人信息详情
    changePassword, // 2.5.右侧下部分个修改密码
    addressList,
  },

  methods: {
    // 3.methods
    clickedBtns(index) {
      // 3.1.按钮回调
      if (this.butsIndex != index) {
        this.butsIndex = index;
        this.obj = this.btns[index];
      }
    },

    getGoodsNumber() {
      // 3.2.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getGoodsNumber(); // 4.1.获取商品数量
    }
  },
};
</script>
